import React from 'react';
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import * as API from '../../appAPI/api';
import VechilesSearchPage from "./VechilesSearchPage";

const VehiclesTotalData = ({handleCurrentPage}) => {
  const [searchPage, setSearchPage] = useState('');
  const [allData, setAllData] = useState('');
  const [sortData, setSortData] = useState('');
  const [totals, setTotals] = useState('');

  const CalculateTotal = (data) => {
    let newData = {...data} 
    let totals = []

    for (let x in newData) {
      let numOfOrders = 0 
      let employerMoney = 0
      // let systemTotalPrice = 0
      let employerInputPrice = 0
      let numOfRounds = 0;
      let expenses = 0;

      for (let y of newData[x].days) {
        for (let z of y.rounds) {
          numOfOrders += Number(z.numOfOrders)
          employerMoney += Number(z.employerMoney)
          // systemTotalPrice += Number(z.systemTotalPrice)
          employerInputPrice += Number(z.employerInputPrice)
        }

        expenses += Number(y.expenses.petrol)
        expenses += Number(y.expenses.oil)
        expenses += Number(y.expenses.repairs)
        numOfRounds += y.rounds.length
      }
      expenses += employerMoney

      totals.push(
        {
        "vehicle": newData[x].vehicle,
        "numOfOrders": numOfOrders,
        "employerInputPrice": employerInputPrice,
        expenses,
        numOfRounds,
        profits: (employerInputPrice - expenses >= 0 ? (employerInputPrice - expenses).toFixed(2) : 0),
        losses: (employerInputPrice - expenses <= 0 ? (employerInputPrice - expenses).toFixed(2) : 0)
      })
    }
    setTotals(totals);
  }

  const SortData = (vData) => {
    let sortData = {}
      for (let x of vData) {
        let obj = {

        }
        for (let y of x.rounds) {
          if (obj.hasOwnProperty(y.vehicle.id)) {
            obj[y.vehicle.id].rounds.push({
              "numOfOrders": y.numOfOrders,
              "employerMoney": y.employerMoney,
              "systemTotalPrice": y.systemTotalPrice,
              "employerInputPrice": y.employerInputPrice,
              "startedAt": y.startedAt,
              "workingHours": y.workingHours,
              "roundID": y.roundID,
              "date": y.date,
              "employer": y.employer
            })
          }else {
            obj[y.vehicle.id] = {
              rounds: [ 
                {
                "numOfOrders": y.numOfOrders,
                "employerMoney": y.employerMoney,
                "systemTotalPrice": y.systemTotalPrice,
                "employerInputPrice": y.employerInputPrice,
                "startedAt": y.startedAt,
                "workingHours": y.workingHours,
                "roundID": y.roundID,
                "date": y.date,
                "employer": y.employer
              }],
              "vehicle": y.vehicle
            }
          }
        }     

        for (let e of x.expenses) {
          if (obj.hasOwnProperty(e.id)) {
            obj[e.id].expenses = e
          }
        }

        for (let a in obj) {
          let newObj = {
            rounds: obj[a].rounds,
            expenses: obj[a].expenses,
            id: x.id,
            date: x.date
          }
          if (sortData.hasOwnProperty(a)) {
            sortData[a].days.push(newObj)
          }else {
            sortData[a] = {
              days: [newObj],
              vehicle: obj[a].vehicle
            }
          }
        }
      }
    return sortData;
  }

  useEffect(() => {
    (async () => {
      const data =  await API.getAllData() 
      let vData = data['employees-vehicles']
      setAllData(vData);

      let sortData = SortData(vData)
      setSortData(sortData)
      CalculateTotal(sortData)
    })()
  } ,[])

  const handleData =({petrolValues, oilValues, repairsValues}, dayID, vehicleID) => {
    let newData= JSON.parse(JSON.stringify(allData))
    for (let day of newData) {
      if (day.id === dayID) {
        day.expenses = day.expenses.map((ve) => {
          if (ve.id === vehicleID) {
            ve.petrol = petrolValues
            ve.oil = oilValues
            ve.repairs = repairsValues
          }
          return ve
        })
      }
    };
    setAllData(newData)
    let sortData = SortData(newData)
    setSortData(sortData)
    CalculateTotal(sortData)
    API.setAllData(newData)
  }

  return (
    <section className="employees-page">
      <section className="admin-page-links">
        <Link to='/delivery-assistant/' className="back-arrow" title="orders page">⟰</Link>
        <p>/</p>
        <button onClick={() => handleCurrentPage('adminHomePage')}>Admin_Page</button>
        {searchPage && 
          <>
            <p>/</p>
            <button onClick={() => setSearchPage('')}>totals_Data</button>
          </>
        }
      </section>

      <h1>Vehicles Data<br /> 
        <span style={{'color': '#537cdc'}}>{!searchPage ? '( Totals )' : sortData[searchPage].vehicle.name}</span>
      </h1>
      <br />

      {!searchPage &&
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Rounds</th>
            <th>Orders</th>
            <th>Money income</th>
            <th>expenses</th>
            <th>Profits</th>
            <th>Losses</th>
            <th></th>
          </tr>
        </thead>

        {totals &&
          <tbody>
            {totals.map((vc) => (
              <tr key={vc.vehicle.id}>
                <td>{vc.vehicle.name}</td>
                <td>{vc.numOfRounds}</td>
                <td>{vc.numOfOrders}</td>
                <td>{vc.employerInputPrice} $</td>
                <td>{vc.expenses} $</td>
                <td>{vc.profits} $</td>
                <td>{vc.losses} $</td>
                <td>
                  <button onClick={() => setSearchPage(vc.vehicle.id)}>Search</button>
              </td>
              </tr>
            ))}
          </tbody>
        }
      </table>
      }
      {searchPage && 
          <VechilesSearchPage
            item={searchPage}
            data={sortData}
            handleData={handleData}
          />
        }
    </section>
  )
}

export default VehiclesTotalData;